'use client';

/**
 * Toast — thin wrapper over `sonner` (already a dependency) so both apps share
 * one toast system. Mount <Toaster/> once at the app root; call toast.* anywhere.
 */
import { Toaster, toast as sonnerToast } from 'sonner';

export { Toaster };

export const toast = {
  success: (message: string, description?: string) => sonnerToast.success(message, { description }),
  error: (message: string, description?: string) => sonnerToast.error(message, { description }),
  warning: (message: string, description?: string) => sonnerToast.warning(message, { description }),
  info: (message: string, description?: string) => sonnerToast.message(message, { description }),
};
